import { NON_BREAKING_SPACE } from '~/src/constants/simbols';

interface IServiceCapability {
    id: number,
    icon: string,
    info: string,
}

export interface IServiceWidget {
    title: string,
    info?: string,
    capabilities: IServiceCapability[],
    price: string,
    link: string,
}

export const services: Record<string, IServiceWidget> = {
    'watch-everywhere': {
        title: '«Смотри везде»',
        info: 'ТВ-каналы, фильмы и подписки можно смотреть на всех экранах с Movix',
        capabilities: [
            {
                id: 1,
                icon: require('/static/images/domru-tv/packages/services/movix.png'),
                info: 'На большом экране',
            },
            {
                id: 2,
                icon: require('/static/images/domru-tv/packages/services/mobile.png'),
                info: 'На мобильных устройствах',
            },
        ],
        price: 'от 0 ₽/мес',
        link: '/domru-tv/watch-everywhere',
    },
    'watch-control': {
        title: `«Управляй просмотром» в${NON_BREAKING_SPACE}Movix`,
        capabilities: [
            {
                id: 1,
                icon: require('/static/images/domru-tv/packages/services/pause.png'),
                info: 'Ставьте прямой эфир на паузу',
            },
            {
                id: 2,
                icon: require('/static/images/domru-tv/packages/services/forward.png'),
                info: 'Перематывайте рекламу',
            },
            {
                id: 3,
                icon: require('/static/images/domru-tv/packages/services/repeat.png'),
                info: 'Смотрите архив программ за неделю',
            },
        ],
        // @TODO нет единой точки входа за этими данными? разобраться в рамках WEB-43437
        price: '90 ₽/мес',
        link: '/catchup',
    },
};
